import React from 'react';
import VimeoPlayer from '@vimeo/player';
import {VimeoVideo} from '@rcm/vimeo';
import PlayerIFrame from './PlayerIFrame';
import {FixedAspectRatioDiv} from '@rcm/fixed-aspect-ratio-div-react';

interface Props {
    video: VimeoVideo;
    mode?: string;
    onCreateVimeoPlayer?: (vimeoPlayer: VimeoPlayer, error?: Error) => void;
    loadedTimeoutMs?: number;
}

const FixedAspectRatioPlayer = ({
    video: {id, width, height},
    mode,
    onCreateVimeoPlayer,
    loadedTimeoutMs,
}: Props) => <FixedAspectRatioDiv aspectRatio={`${width}:${height}`}>
    <PlayerIFrame
        videoId={id}
        mode={mode}
        onCreateVimeoPlayer={onCreateVimeoPlayer}
        loadedTimeoutMs={loadedTimeoutMs}
    />
</FixedAspectRatioDiv>;

export default FixedAspectRatioPlayer;
